/*
 *
 * StudentsDetail actions
 *
 */

import {
  FLUSH_STATE,
  LOAD_STUDENT,
  LOAD_STUDENT_SUCCESS,
  LOAD_STUDENT_ERROR,
  CHANGE_STUDENT,
  CHANGE_STUDENT_SUCCESS,
  CHANGE_STUDENT_ERROR,
} from './constants';

export function flushState() {
  return {
    type: FLUSH_STATE,
  };
}

/**
 * Load the student, this action starts the request saga
 *
 * @return {object} An action object with a type of LOAD_STUDENTS */

export function loadStudent(id) {
  return {
    type: LOAD_STUDENT,
    id,
  };
}

/**
 * Dispatched when the loadStudent are loaded by the request saga
 *
 * @param  {array} Student true for student
 *
 * @return {object}      An action object with a type of LOAD_STUDENTS_SUCCESS passing the student */

export function loadStudentSuccess(itemData) {
  return {
    type: LOAD_STUDENT_SUCCESS,
    itemData,
  };
}

/**
 * Dispatched when loading the loadStudents fails
 *
 * @param  {object} error The error
 *
 * @return {object}       An action object with a type of LOAD_STUDENTS_ERROR passing the error */

export function loadStudentError(error) {
  return {
    type: LOAD_STUDENT_ERROR,
    error,
  };
}

// Change Student
export function changeStudent(itemData) {
  return {
    type: CHANGE_STUDENT,
    itemData,
  };
}
export function changeStudentSuccess(itemData) {
  return {
    type: CHANGE_STUDENT_SUCCESS,
    itemData,
  };
}
export function changeStudentError(error) {
  return {
    type: CHANGE_STUDENT_ERROR,
    error,
  };
}
